// components/admin/accounting/ProviderStatisticsCards.jsx
import React from 'react';
import { TrendingUp, TrendingDown, Package, DollarSign, Truck, MapPin, ShoppingBag } from 'lucide-react';

function ProviderStatisticsCards({ statistics, userType }) {
  const lima = statistics.lima || {};
  const provincia = statistics.provincia || {};

  return (
    <div className="space-y-6 mb-6">
  {/* Combined Overview Cards */}
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
    {/* Show ONLY for linked users */}
    {userType === 'linked' && (
      <>
        {/* Total Collected */}
        <div className="bg-white rounded-xl shadow-sm border-2 border-slate-200 p-6">
          <div className="flex items-center justify-between mb-3">
            <div className="w-12 h-12 bg-brand-primary/10 rounded-lg flex items-center justify-center">
              <TrendingUp className="w-6 h-6 text-brand-primary" />
            </div>
            <span className="text-3xl font-extrabold text-slate-900 font-montserrat">
              {statistics.total_collected?.toFixed(0) || 0}
            </span>
          </div>
          <h3 className="text-sm font-semibold text-slate-700 font-montserrat mb-2">
            Total Recaudado (S/)
          </h3>
          <div className="flex gap-2 text-xs text-slate-600 font-montserrat">
            <span className="bg-brand-primary/10 px-2 py-1 rounded">
              Lima: {lima.collected?.toFixed(2) || 0}
            </span>
            <span className="bg-brand-gold/10 px-2 py-1 rounded">
              Prov: {provincia.collected?.toFixed(2) || 0}
            </span>
          </div>
        </div>

        {/* Total Service Fee (Cost to Provider) */}
        <div className="bg-white rounded-xl shadow-sm border-2 border-slate-200 p-6">
          <div className="flex items-center justify-between mb-3">
            <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
              <DollarSign className="w-6 h-6 text-red-600" />
            </div>
            <span className="text-3xl font-extrabold text-slate-900 font-montserrat">
              {statistics.total_service_fee?.toFixed(0) || 0}
            </span>
          </div>
          <h3 className="text-sm font-semibold text-slate-700 font-montserrat mb-2">
            Costo Servicio (S/)
          </h3>
          <div className="flex gap-2 text-xs text-slate-600 font-montserrat">
            <span className="bg-red-100 px-2 py-1 rounded">
              Lima: {lima.service_fee?.toFixed(2) || 0}
            </span>
            <span className="bg-red-100 px-2 py-1 rounded">
              Prov: {provincia.service_fee?.toFixed(2) || 0}
            </span>
          </div>
        </div>

        {/* Total to Provider */}
        <div className="bg-gradient-to-br from-brand-gold to-brand-primary rounded-xl shadow-lg p-6 text-white">
          <div className="flex items-center justify-between mb-3">
            <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
              <Package className="w-6 h-6" />
            </div>
            <span className="text-3xl font-extrabold font-montserrat">
              {statistics.total_to_provider?.toFixed(2) || 0}
            </span>
          </div>
          <h3 className="text-sm font-semibold font-montserrat mb-2">
            Total para Proveedor (S/)
          </h3>
          <div className="flex gap-2 text-xs font-montserrat">
            <span className="bg-white/20 px-2 py-1 rounded">
              Lima: {lima.to_provider?.toFixed(2) || 0}
            </span>
            <span className="bg-white/20 px-2 py-1 rounded">
              Prov: {provincia.to_provider?.toFixed(2) || 0}
            </span>
          </div>
        </div>
      </>
    )}

    {/* Dropship Earnings - ONLY show for dropship users */}
    {userType === 'dropship' && statistics.total_dropship_earnings > 0 && (
      <div className="bg-white rounded-xl shadow-sm border-2 border-purple-200 p-6">
        <div className="flex items-center justify-between mb-3">
          <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
            <ShoppingBag className="w-6 h-6 text-purple-600" />
          </div>
          <span className="text-3xl font-extrabold text-slate-900 font-montserrat">
            {statistics.total_dropship_earnings?.toFixed(0) || 0}
          </span>
        </div>
        <h3 className="text-sm font-semibold text-slate-700 font-montserrat mb-2">
          Ganancia Dropship (S/)
        </h3>
        <div className="flex gap-2 text-xs text-slate-600 font-montserrat">
          <span className="bg-purple-100 px-2 py-1 rounded">
            Lima: {lima.dropship_earnings?.toFixed(2) || 0}
          </span>
          <span className="bg-purple-100 px-2 py-1 rounded">
            Prov: {provincia.dropship_earnings?.toFixed(2) || 0}
          </span>
        </div>
      </div>
    )}
  </div>

  {/* Detailed Breakdown - Lima and Provincia */}
  {userType === 'linked' && (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      {/* Lima Breakdown */}
      <div className="bg-white rounded-xl shadow-sm border-2 border-brand-primary/30 p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-brand-primary/10 rounded-lg flex items-center justify-center">
            <Truck className="w-5 h-5 text-brand-primary" />
          </div>
          <h3 className="text-lg font-extrabold text-brand-primary font-montserrat">
            Entregas Lima
          </h3>
        </div>

        <div className="space-y-3">
          <div className="flex justify-between items-center py-2 border-b border-slate-200">
            <span className="text-sm text-slate-600 font-montserrat">Entregas totales</span>
            <span className="text-lg font-bold text-slate-900 font-montserrat">
              {lima.count || 0}
            </span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-slate-200">
            <span className="text-sm text-slate-600 font-montserrat">Cobrado</span>
            <span className="text-lg font-bold text-brand-primary font-montserrat">
              S/ {lima.total_charged?.toFixed(2) || 0}
            </span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-slate-200">
            <span className="text-sm text-slate-600 font-montserrat">Transferencias FastMax</span>
            <span className="text-lg font-bold text-brand-gold font-montserrat">
              S/ {lima.total_fastmax?.toFixed(2) || 0}
            </span>
          </div>
          {lima.total_exchange > 0 && (
            <div className="flex justify-between items-center py-2 border-b border-slate-200">
              <span className="text-sm text-slate-600 font-montserrat">Vuelto</span>
              <span className="text-lg font-bold text-red-600 font-montserrat">
                - S/ {lima.total_exchange?.toFixed(2) || 0}
              </span>
            </div>
          )}
          <div className="flex justify-between items-center py-2 border-b border-slate-200">
            <span className="text-sm text-slate-600 font-montserrat">Servicio FastMax</span>
            <span className="text-lg font-bold text-red-600 font-montserrat">
              - S/ {lima.service_fee?.toFixed(2) || 0}
            </span>
          </div>
          <div className="flex justify-between items-center pt-3 border-t-2 border-brand-primary">
            <span className="text-sm font-bold text-brand-primary font-montserrat">Para Proveedor</span>
            <span className="text-2xl font-extrabold text-brand-primary font-montserrat">
              S/ {lima.to_provider?.toFixed(2) || 0}
            </span>
          </div>
        </div>
      </div>

      {/* Provincia Breakdown */}
      <div className="bg-white rounded-xl shadow-sm border-2 border-brand-gold/30 p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-brand-gold/10 rounded-lg flex items-center justify-center">
            <MapPin className="w-5 h-5 text-brand-gold" />
          </div>
          <h3 className="text-lg font-extrabold text-brand-gold font-montserrat">
            Entregas Provincia
          </h3>
        </div>

        <div className="space-y-3">
          <div className="flex justify-between items-center py-2 border-b border-slate-200">
            <span className="text-sm text-slate-600 font-montserrat">Entregas totales</span>
            <span className="text-lg font-bold text-slate-900 font-montserrat">
              {provincia.count || 0}
            </span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-slate-200">
            <span className="text-sm text-slate-600 font-montserrat">Cobrado</span>
            <span className="text-lg font-bold text-brand-gold font-montserrat">
              S/ {provincia.total_charged?.toFixed(2) || 0}
            </span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-slate-200">
            <span className="text-sm text-slate-600 font-montserrat">Adelanto</span>
            <span className="text-lg font-bold text-brand-gold font-montserrat">
              S/ {provincia.total_advance?.toFixed(2) || 0}
            </span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-slate-200">
            <span className="text-sm text-slate-600 font-montserrat">Servicio FastMax</span>
            <span className="text-lg font-bold text-red-600 font-montserrat">
              - S/ {provincia.service_fee?.toFixed(2) || 0}
            </span>
          </div>
          {provincia.transport_cost > 0 && (
            <div className="flex justify-between items-center py-2 border-b border-slate-200">
              <span className="text-sm text-slate-600 font-montserrat">Transporte</span>
              <span className="text-lg font-bold text-red-600 font-montserrat">
                - S/ {provincia.transport_cost?.toFixed(2) || 0}
              </span>
            </div>
          )}
          <div className="flex justify-between items-center pt-3 border-t-2 border-brand-gold">
            <span className="text-sm font-bold text-brand-gold font-montserrat">Para Proveedor</span>
            <span className="text-2xl font-extrabold text-brand-gold font-montserrat">
              S/ {provincia.to_provider?.toFixed(2) || 0}
            </span>
          </div>
        </div>
      </div>
    </div>
  )}

  {/* Dropship Details - ONLY for dropship users */}
  {userType === 'dropship' && (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      {/* Lima Dropship Breakdown */}
      {lima.dropship_earnings > 0 && (
        <div className="bg-white rounded-xl shadow-sm border-2 border-purple-200 p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
              <ShoppingBag className="w-5 h-5 text-purple-600" />
            </div>
            <h3 className="text-lg font-extrabold text-purple-600 font-montserrat">
              Dropship Lima
            </h3>
          </div>

          <div className="space-y-3">
            <div className="flex justify-between items-center py-2 border-b border-slate-200">
              <span className="text-sm text-slate-600 font-montserrat">Entregas dropship</span>
              <span className="text-lg font-bold text-slate-900 font-montserrat">
                {lima.count || 0}
              </span>
            </div>
            <div className="flex justify-between items-center pt-3 border-t-2 border-purple-600">
              <span className="text-sm font-bold text-purple-600 font-montserrat">Ganancia Total</span>
              <span className="text-2xl font-extrabold text-purple-600 font-montserrat">
                S/ {lima.dropship_earnings?.toFixed(2) || 0}
              </span>
            </div>
          </div>
        </div>
      )}

      {/* Provincia Dropship Breakdown */}
      {provincia.dropship_earnings > 0 && (
        <div className="bg-white rounded-xl shadow-sm border-2 border-purple-200 p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
              <ShoppingBag className="w-5 h-5 text-purple-600" />
            </div>
            <h3 className="text-lg font-extrabold text-purple-600 font-montserrat">
              Dropship Provincia
            </h3>
          </div>

          <div className="space-y-3">
            <div className="flex justify-between items-center py-2 border-b border-slate-200">
              <span className="text-sm text-slate-600 font-montserrat">Entregas dropship</span>
              <span className="text-lg font-bold text-slate-900 font-montserrat">
                {provincia.count || 0}
              </span>
            </div>
            <div className="flex justify-between items-center pt-3 border-t-2 border-purple-600">
              <span className="text-sm font-bold text-purple-600 font-montserrat">Ganancia Total</span>
              <span className="text-2xl font-extrabold text-purple-600 font-montserrat">
                S/ {provincia.dropship_earnings?.toFixed(2) || 0}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  )}

  {/* Performance Metrics */}
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
    <div className="bg-white rounded-xl shadow-sm border-2 border-slate-200 p-6">
      <div className="flex items-center justify-between">
        <span className="text-sm text-slate-600 font-montserrat">Tasa de Éxito</span>
        <span className="text-2xl font-extrabold text-green-600 font-montserrat">
          {statistics.success_rate}%
        </span>
      </div>
    </div>
    <div className="bg-white rounded-xl shadow-sm border-2 border-slate-200 p-6">
      <div className="flex items-center justify-between">
        <span className="text-sm text-slate-600 font-montserrat">Tasa de Rechazo</span>
        <span className="text-2xl font-extrabold text-red-600 font-montserrat">
          {statistics.rejection_rate}%
        </span>
      </div>
    </div>
    {userType === 'dropship' && (
      <div className="bg-white rounded-xl shadow-sm border-2 border-purple-200 p-6">
        <div className="flex items-center justify-between">
          <span className="text-sm text-slate-600 font-montserrat">Entregas Dropship</span>
          <span className="text-2xl font-extrabold text-purple-600 font-montserrat">
            {statistics.total_dropship_deliveries || 0}
          </span>
        </div>
      </div>
    )}
  </div>
</div>
  );
}

export default ProviderStatisticsCards;